<template>
    <div>
        <!-- Mobile: centered modal -->
        <MobileModal v-if="openUp" :is-open="isVisible" :title="title" max-width="360px" @close="$emit('close')">
            <ul role="listbox" class="m-0 list-none py-1">
                <li
                    v-for="(item, index) in normalizedVoices"
                    :key="item.key"
                    role="option"
                    :aria-selected="item.key === selectedVoice"
                    class="flex cursor-pointer items-center justify-between px-4 py-3 text-[15px] transition-colors duration-100 active:bg-theme-icon-bg"
                    :class="{
                        'font-semibold text-theme-icon': item.key === selectedVoice,
                    }"
                    @click="$emit('select', item.key)"
                >
                    <span>
                        <slot name="item" :item="item.data" :index="index">
                            {{ item.label }}
                        </slot>
                    </span>
                    <svg-icon
                        v-if="item.key === selectedVoice"
                        icon="check"
                        width="16"
                        height="16"
                        class="ml-2 shrink-0"
                    />
                </li>
            </ul>
        </MobileModal>

        <!-- Desktop: dropdown -->
        <transition v-else name="slide-fade">
            <div v-show="isVisible" class="absolute right-0 top-0 z-400 text-theme-text">
                <ul
                    role="listbox"
                    :aria-label="'Voice selection menu'"
                    class="absolute right-0 m-2 max-h-[900px] min-w-full list-none overflow-y-auto rounded bg-theme-bg-card p-0 shadow"
                >
                    <li
                        v-for="(item, index) in normalizedVoices"
                        :key="item.key"
                        role="option"
                        tabindex="0"
                        :aria-selected="item.key === selectedVoice"
                        class="min-w-[150px] cursor-pointer whitespace-nowrap px-3 py-2 hover:bg-theme-icon-bg focus-visible:bg-theme-icon-bg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-theme-accent active:bg-theme-icon-bg"
                        :class="{ 'bg-theme-icon-bg': item.key === selectedVoice }"
                        @click="$emit('select', item.key)"
                        @keydown.enter.prevent="$emit('select', item.key)"
                        @keydown.space.prevent="$emit('select', item.key)"
                    >
                        <span>
                            <slot name="item" :item="item.data" :index="index">
                                {{ item.label }}
                            </slot>
                        </span>
                    </li>
                </ul>
            </div>
        </transition>
    </div>
</template>

<script>
'use strict';

import MobileModal from '_shared_/UI/Components/MobileModal.vue';

export default {
    name: 'ChangeVoiceMenu',
    components: {
        MobileModal,
    },
    props: {
        isVisible: {
            type: Boolean,
            default: false,
        },
        voices: {
            type: [Array, Object],
            required: true,
        },
        selectedVoice: {
            type: [String, Number],
            default: null,
        },
        openUp: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: 'Voz',
        },
    },
    emits: ['select', 'close'],
    computed: {
        normalizedVoices() {
            if (Array.isArray(this.voices)) {
                return this.voices.map((voice, index) => ({
                    key: index,
                    label: voice.name || voice.label || voice,
                    data: voice,
                }));
            }
            return Object.entries(this.voices).map(([key, value]) => ({
                key,
                label: `${key} (${value})`,
                data: value,
            }));
        },
    },
};
</script>

<style scoped>
.slide-fade-enter-active {
    @apply transition-all duration-300 ease-in-out;
}

.slide-fade-leave-active {
    @apply transition-all duration-100 ease-[cubic-bezier(1,0.5,0.8,1)];
}

.slide-fade-enter,
.slide-fade-leave-to {
    @apply -translate-y-2.5 opacity-0;
}

@media (prefers-reduced-motion: reduce) {
    .slide-fade-enter-active,
    .slide-fade-leave-active {
        @apply transition-none;
    }
}
</style>
